import store from '@/store'

let uvLoadingPromise = null
let uvInstance = null

const loadUniversalViewerScript = () => new Promise((resolve, reject) => {
  const script = document.createElement('script')
  const cacheVersion = window.getUniversalViewerVersion ? encodeURIComponent(window.getUniversalViewerVersion()) : ''
  script.onload = resolve
  script.onerror = reject
  script.async = true
  script.type = 'text/javascript'
  script.src = `webman/3rdparty/UniversalViewer/uv.loader.js${cacheVersion ? (`?v=${cacheVersion}`) : ''}`

  document.head.appendChild(script)
})

const getUVIframeDocument = () => {
  const iframe = document.querySelector('iframe.syno-uv-main')
  return iframe?.contentDocument
}

const createUniversalViewer = async (rootEl) => {
  uvInstance = await window.UV.createUniversalViewer({
    hideHeader: true,
    rootEl: rootEl || document.body,
    lang: store.state.appData.Session.lang,
    autoClose: false,
    csp: false,
  })

  const iframeDocument = getUVIframeDocument()
  
  if (!iframeDocument) {
    return
  }

  injectStyleIntoIframe(iframeDocument)

  return uvInstance
}

const uvStyle = `
.holder {
  background: none !important;
  outline: none !important;
}

.tbar {
  visibility: hidden !important;
  max-height: 0 !important;
  max-width: 0 !important;
}

.view {
  height: 100% !important;
}

.uv-archive-view .view {
  top: 0 !important;
  height: calc(100vh - 60px) !important;
}
`

const injectStyleIntoIframe = (iframeDocument) => {
  const injectedStyle = document.createElement('style')
  injectedStyle.textContent = uvStyle
  iframeDocument.head.appendChild(injectedStyle)
}

const loadUniversalViewer = (rootEl) => {
  if (uvLoadingPromise) {
    return uvLoadingPromise
  }

  uvLoadingPromise = (async () => {
    await loadUniversalViewerScript()
    const uv = await createUniversalViewer(rootEl)
    return uv
  })()

  return uvLoadingPromise
}

export default loadUniversalViewer
